/* @flow */

export default class ProfileSummaryCard {
  type: number;
  valueType: number;
  value: number;
}
